// extracted by mini-css-extract-plugin
module.exports = {"ErrorMsg":"SignIn_ErrorMsg__3Obnw","Container":"SignIn_Container__37WjC","Logo":"SignIn_Logo__eHq5s"};